import clsx from 'clsx';
import React from 'react';

interface BulletProps {
  step: number;
  className?: string;
}

const Bullet: React.FC<BulletProps> = ({ step, className = 'h-6 w-6 min-w-6 bg-primary text-white' }) => (
  <div className='self-start'>
    <span className={clsx('flex items-center justify-center rounded-full font-semibold', className)}>{step}</span>
  </div>
);

export default Bullet;
